import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import smoothscroll from 'smoothscroll-polyfill';

import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';

import Routes from './routes';
import store from './store';
import * as serviceWorker from './serviceWorker';

import './assets/scss/app.scss';

document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
     // tab is changed
  } else {
     document.title = 'TrueLark';
  }
});
function App() {
  // Initialize GA
  ReactGA.initialize(window.Config.GA_TRACKING_ID);
  smoothscroll.polyfill();

  return (
    <Provider store={store}>
      <Routes {...store} />
    </Provider>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
